import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Auth
export const registerAuthService = (data) => {
  return http.post(`${base_url}/auth/register`, data);
};
export const confirmRegisterAuthService = (data, token) => {
  return http.patch(`${base_url}/auth/register/confirm`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const loginAuthService = (data) => {
  return http.post(`${base_url}/auth/login`, data);
};
export const sendLoginOTPAuthService = (data) => {
  return http.patch(`${base_url}/auth/login/otp/send`, data);
};
export const verifyLoginOTPAuthService = (data) => {
  return http.post(`${base_url}/auth/login/otp/verify`, data);
};
export const forgotPasswordAuthService = (data) => {
  return http.put(`${base_url}/auth/forgot-password`, data);
};
// End Auth

// Start OTP
export const sendPhoneNumberOTPUserService = (data) => {
  return http.post(`${base_url}/user/phone-number/otp/send`, data);
};
export const verifyPhoneNumberOTPUserService = (data) => {
  return http.patch(`${base_url}/user/phone-number/otp/verify`, data);
};
export const sendEmailOTPUserService = (data) => {
  return http.post(`${base_url}/user/email/otp/send`, data);
};
export const verifyEmailOTPUserService = (data) => {
  return http.patch(`${base_url}/user/email/otp/verify`, data);
};
// End OTP

// Start Change Password
export const changePasswordAuthService = (data) => {
  return http.post(`${base_url}/user/change-password`, data);
};
// End Change Password

// Start Info
export const getInfoUserService = () => {
  return http.get(`${base_url}/user/info`);
};
export const editInfoUserService = (data) => {
  return http.put(`${base_url}/user/info`, data);
};
// End Info

// Start Upload
export const uploadUserService = (data, params) => {
  return http.post(`${base_url}/user/upload`, data, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
// End Upload

// Start Notification
export const getNotificationsUserService = (params) => {
  return http.get(`${base_url}/user/notification`, { params });
};
export const deleteAllNotificationUserService = () => {
  return http.delete(`${base_url}/user/notification`);
};
export const deleteNotificationUserService = (id) => {
  return http.delete(`${base_url}/user/notification/${id}`);
};
export const readNotificationUserService = (id) => {
  return http.patch(`${base_url}/user/notification/${id}/read`);
};
export const readAllNotificationUserService = () => {
  return http.patch(`${base_url}/user/notification/read`);
};
// End Notification

// Start Meta
export const getMetaUserService = () => {
  return http.get(`${base_url}/user/meta`);
};
// End Meta

// Start Transaction
export const getTransactionsUserService = (params) => {
  return http.get(`${base_url}/user/transactions`, { params });
};
// End Transaction

// Start Ticket
export const createTicketUserService = (data) => {
  return http.post(`${base_url}/user/ticket`, data);
};
export const getTicketsUserService = (params) => {
  return http.get(`${base_url}/user/tickets`, { params });
};
export const getTicketUserService = (id) => {
  return http.get(`${base_url}/user/ticket/${id}`);
};
export const sendTicketMessageUserService = (data) => {
  return http.put(`${base_url}/user/ticket/${data.id}`, data);
};
export const closeTicketUserService = (id) => {
  return http.patch(`${base_url}/user/ticket/${id}`);
};
export const deleteTicketUserService = (id) => {
  return http.delete(`${base_url}/user/ticket/${id}`);
};
export const assignTicketUserService = (data) => {
  return http.patch(`${base_url}/user/ticket/${data.id}/assign`, data);
};
// End Ticket

// Start Order
export const getOrdersUserService = (params) => {
  return http.get(`${base_url}/user/order`, { params });
};
export const createOrderUserService = (data) => {
  return http.post(`${base_url}/user/order`, data);
};
export const editOrderUserService = (data) => {
  return http.put(`${base_url}/user/order/${data.id}`, data);
};
export const deleteOrderUserService = (id) => {
  return http.delete(`${base_url}/user/order/${id}`);
};
// Start Order

// Start Discount Code
export const checkDiscountCodeUserService = (params) => {
  return http.get(
    `${base_url}/user/discount-code/${params.code}/${params.product}`,
    { params }
  );
};
// End Discount Code

// Start Invoice
export const getInvoicesUserService = (params) => {
  return http.get(`${base_url}/user/invoices`, { params });
};
export const payInvoiceUserService = (data) => {
  return http.patch(`${base_url}/user/invoice/${data.id}`, data);
};
// End Invoice

// Start Renewal
export const getRenewalsUserService = (params) => {
  return http.get(`${base_url}/user/renewals`, { params });
};
// End Renewal

// Start Payment
export const getPaymentsUserService = (params) => {
  return http.get(`${base_url}/user/payments`, { params });
};
// End Payment

// Start Wallet
export const chargeWalletUserService = (data) => {
  return http.post(`${base_url}/user/wallet`, data);
};
// End Wallet

// Start Accept Terms
export const acceptTermsUserService = (data) => {
  return http.patch(`${base_url}/user/accept-terms`, data);
};
// End Accept Terms

// Start Overview
export const getOverviewUserService = () => {
  return http.get(`${base_url}/user/overview`);
};
// End Overview
